import { createSlice } from '@reduxjs/toolkit';

import authService from 'modules/auth/service';
import dealersApi from '../dealers/service';
import selfServicesApi from '../selfServices/service';
import { formatPhoneNumber } from './utils';
import { CommunicationState } from './types/CommunicationState';
import { WhatsAppStatusEnum } from '../auth/types/LoginRequest';

const initialState: CommunicationState = {};

const communicationSlice = createSlice({
  name: 'communication',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(dealersApi.endpoints.getContext.matchFulfilled, (state, action) => {
      const { interventionLastMessageChannel, whatsApp } = action.payload ?? {};
      return {
        ...state,
        interventionLastMessageChannel: interventionLastMessageChannel ?? state.interventionLastMessageChannel,
        whatsApp: { ...(state.whatsApp ?? {}), ...whatsApp },
      };
    });
    builder.addMatcher(authService.endpoints.getMFAConnection.matchFulfilled, (state, action) => {
      // eslint-disable-next-line max-len
      const { email, phoneNumber, interventionLastMessageChannel, whatsApp, smsRetryExpiration, emailRetryExpiration, whatsAppRetryExpiration } = action.payload ?? {};
      return {
        ...state,
        email,
        phoneNumber,
        interventionLastMessageChannel,
        whatsApp: { ...(state.whatsApp ?? {}), ...whatsApp },
        smsRetryExpiration,
        emailRetryExpiration,
        whatsAppRetryExpiration,
      };
    });
    builder.addMatcher(authService.endpoints.sendMFACode.matchFulfilled, (state, action) => {
      const { smsRetryExpiration, emailRetryExpiration, whatsAppRetryExpiration } = action.payload ?? {};
      return {
        ...state,
        smsRetryExpiration,
        emailRetryExpiration,
        whatsAppRetryExpiration,
      };
    });
    builder.addMatcher(authService.endpoints.login.matchFulfilled, (state) => ({
      ...state,
      smsRetryExpiration: undefined,
      emailRetryExpiration: undefined,
      whatsAppRetryExpiration: undefined,
    }));
    builder.addMatcher(selfServicesApi.endpoints.getSelfServiceById.matchFulfilled, (state, action) => {
      const { email, phoneNumber } = action.payload?.customerInfo ?? {};
      return {
        ...state,
        email,
        phoneNumber: formatPhoneNumber(phoneNumber),
      };
    });
    builder.addMatcher(selfServicesApi.endpoints.updateCustomerInfo.matchFulfilled, (state, action) => {
      const { email, phoneNumber } = action.payload?.customerInfo ?? {};

      const newPhoneNumber = formatPhoneNumber(phoneNumber);
      const hasChangePhoneNumber = state.phoneNumber !== newPhoneNumber;
      const newWhatsAppStatus = hasChangePhoneNumber ? WhatsAppStatusEnum.UNREACHABLE : state.whatsApp?.status;

      return {
        ...state,
        email,
        phoneNumber: newPhoneNumber,
        whatsApp: { ...(state.whatsApp ?? { enabled: false }), status: newWhatsAppStatus },
      };
    });
  },
});

export default communicationSlice;
